import { ParameterType } from '@/study-search/enums';

import { Filter } from '../Filter';
import { IIndexation } from '../../../interfaces';
import { FormatFilterOptionValue, FilterKey } from '@studyportals/search-filters/server-side';

export class FormatFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.ATTENDANCE, ParameterType.ATTENDANCE, []);
	}

	public canBeIndexed(): boolean {
		return (
			this.values.length === 1 &&
			(this.values.includes(FormatFilterOptionValue.PART_TIME) ||
				this.values.includes(FormatFilterOptionValue.FULL_TIME))
		);
	}
}
